// Traductions du mode Lite : réglages (mode d'affichage).
export const fr = {};

export const en: typeof fr = {};
